import { useEffect } from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import DipAnimation from './components/DipAnimation/DipAnimation';
import Problem from './components/Problem/Problem';
import Solution from './components/Solution/Solution';
import EvalSection from './components/EvalSection/EvalSection';
import Restaurant from './components/Restaurant/Restaurant';
import HomeBBQ from './components/HomeBBQ/HomeBBQ';
import ForPets from './components/ForPets/ForPets';
import Testimonials from './components/Testimonials/Testimonials';
import CTA from './components/CTA/CTA';
import Footer from './components/Footer/Footer';
import { trackPageView } from './utils/analytics';
import './App.css';

function App() {
  // Track initial page view
  useEffect(() => {
    trackPageView('/', 'Rib-n-Dip - No Rib Left Dry');
  }, []);

  return (
    <div className="app">
      <Header />
      <main>
        <Hero />
        <DipAnimation />
        <Problem />
        <Solution />
        <Restaurant />
        <HomeBBQ />
        <EvalSection />
        <ForPets />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
